module.exports = __webpack_public_path__ + "f572638f/img/logo_sourcery.b41c4452.svg";